<template>
  <div class="password-confirm-input">
    <div class="form-group row" :class="{ 'has-feedback' : isDirty }">
      <label  class="col-form-label"
        :for="options.name"
        :class="options.fullWidth ? 'col-sm-12' : 'col-sm-4 col-form-label'">
        {{ options.label }}
        <span v-if="options.required" class="required">*</span>
      </label>
      <div :class="options.fullWidth ? 'col-sm-12' : 'col-sm-8'">
        <input class="form-control" type="password"
          :id="options.name"
          :value="value"
          @input="validate($event.target.value)"
          :name="options.name"/>
        <span :class="validationIcon" v-show="validationIcon"></span>
      </div>
    </div>
    <div class="form-group row" :class="{ 'has-feedback' : isDirty }">
      <label  class="col-form-label"
        for="confirm"
        :class="options.fullWidth ? 'col-sm-12' : 'col-sm-4 col-form-label'">
        Confirm {{ options.label }}
        <span v-if="options.required" class="required">*</span>
      </label>
      <div :class="options.fullWidth ? 'col-sm-12' : 'col-sm-8'">
        <input class="form-control" type="password"
          id="confirm"
          v-model="confirmValue"
          @input="validate()"
          name="confirm"/>
        <span :class="validationClass" v-show="validationMessage">
          {{ validationMessage }}
        </span>
        <span :class="validationIcon" v-show="validationIcon"></span>
      </div>
    </div>
  </div>
</template>

<script>
import {
  validationClass,
  validationIcon,
  validationMessage
} from '@/util/helpers'

export default {
  name: 'PasswordConfirmInput',
  props: {
    value: {
      type: String
    },
    options: {
      type: Object,
      default () {
        return {
          value: '',
          valid: false,
          dirty: false
        }
      }
    }
  },
  computed: {
    validationClass,
    validationMessage,
    validationIcon,
    invalidMessage () {
      if (!this.isLength && this.value) {
        return 'Passwords must be at least ' + this.minLength + ' characters long'
      } else if (!this.isMatch) {
        if (this.confirmValue) {
          return 'Passwords do not match'
        } else {
          return 'Confirm password'
        }
      } else {
        return this.options.label + ' is required'
      }
    }
  },
  data () {
    return {
      minLength: 6,
      confirmValue: '',
      isLength: false,
      isMatch: true,
      isDirty: false,
      isValid: false
    }
  },
  mounted () {
    if (this.options.minLength) {
      this.minLength = this.options.minLength
    }
  },
  methods: {
    validate (val = this.value) {
      this.$emit('input', val)
      if (val) {
        this.isDirty = true
        this.isLength = this.isValid = val.length >= this.minLength
        if (this.isLength) {
          this.isMatch = this.isValid = val === this.confirmValue
        }
      } else if (this.options.required) {
        this.isValid = false
        this.isDirty = true
      } else {
        this.isValid = true
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/PasswordConfirmInput.vue